var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileUpload(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6776 10.4H7.61294C7.27378 10.4 7 10.0873 7 9.7C7 9.31267 7.27378 9 7.61294 9H10.6776C11.0168 9 11.2906 9.31267 11.2906 9.7C11.2906 10.0873 11.0168 10.4 10.6776 10.4ZM15.3871 16H7.62316C7.284 16 7.01022 15.6873 7.01022 15.3C7.01022 14.9127 7.284 14.6 7.62316 14.6H15.3871C15.7262 14.6 16 14.9127 16 15.3C16 15.6873 15.7262 16 15.3871 16Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5648 4.05469L18.3328 9.82266C18.4641 9.95391 18.5391 10.1344 18.5391 10.3195V19.2891C18.5391 19.6781 18.225 19.9922 17.8359 19.9922H6.11719C5.72812 19.9922 5.41406 19.6781 5.41406 19.2891V4.75781C5.41406 4.36875 5.72812 4.05469 6.11719 4.05469H12.5648ZM13.1484 2.64844H5.41406C4.63828 2.64844 4.00781 3.27891 4.00781 4.05469V19.9922C4.00781 20.768 4.63828 21.3984 5.41406 21.3984H18.5391C19.3148 21.3984 19.9453 20.768 19.9453 19.9922V9.44531L13.1484 2.64844Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5547 6.04453L16.5492 8.03906H14.5547V6.04453ZM13.1484 2.64844V8.74219C13.1484 9.13125 13.4625 9.44531 13.8516 9.44531H19.9453L13.1484 2.64844Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUpload);
export default __webpack_public_path__ + "static/media/fileUpload.92d64acd7fe4938113dc10de692cfead.svg";
export { ForwardRef as ReactComponent };